export function objToArray(obj) {
  if (obj && !Array.isArray(obj)) {
    let arr = [];
    arr.push(obj);
    obj = arr;
  }
  return obj;
}

export function getKeys(datas, itemMainKey = "domid") {
  datas = objToArray(datas);
  return datas.map(data => data[itemMainKey]);
}

export function filterDatas(
  data,
  v,
  searchKeys = ["name", "ecologyPinyinSearch"]
) {
  if (!v) return data;
  return data
    .map(d => {
      const _d = { ...d };
      const keys = searchKeys.filter(key => d[key] && d[key].indexOf(v) >= 0);
      if (keys.length > 0) {
        const _childs = d.childs
          ? filterDatas([...d.childs], v, searchKeys)
          : null;
        _d.isFind = true;
        _d.isLeaf = !(_childs && _childs.length);
        _d.isParent = !_d.isLeaf;
        if (_childs && _childs.length) {
          _d.childs = _childs;
        } else {
          delete _d.childs;
        }
      } else if (d.childs && d.childs.length > 0) {
        const childs = filterDatas(d.childs, v, searchKeys);
        const _childs = childs.filter(c => c.isFind);
        if (_childs.length === 0) {
          _d.isFind = false;
        } else {
          _d.isFind = true;
          _d.childs = childs;
        }
      } else {
        _d.isFind = false;
      }
      return _d;
    })
    .filter(c => c.isFind);
}

export function changeValue(data, itemMainKey, id, key, value) {
  data.forEach(d => {
    if (d[itemMainKey] === id) {
      d[key] = value;
      return;
    }
    if (d.childs && !!d.childs.length) {
      changeValue(d.childs, itemMainKey, id, key, value);
    }
  });
}

export function traverTree(data, handler, parent) {
  if (!data) return;
  if (Array.isArray(data)) {
    data.forEach(d => traverTree(d, handler, parent));
  } else {
    if (typeof handler == "function") {
      handler(data, parent);
    }
    if (data.childs) {
      traverTree(data.childs, handler, data);
    }
  }
}

// 添加节点是否可展开标识，即是否有子集
export function addLeaf(datas) {
  datas = objToArray(datas);
  return datas.map(data => {
    const _data = { ...data };
    if ("isLeaf" in data) return _data;
    if (data.childs && data.childs.length > 0) {
      _data.isLeaf = false;
      _data.childs = addLeaf(data.childs);
    } else {
      _data.isLeaf = true;
    }
    return _data;
  });
}

// 获取 maxLev 级树的数据
export function getDefautDatasShow(datas, maxLev, lev = 1) {
  datas = objToArray(datas);
  return lev > maxLev
    ? []
    : datas.map(data => {
        const _data = { ...data };
        if (_data.childs && _data.childs.length > 0) {
          _data.childs = getDefautDatasShow(data.childs, maxLev, lev + 1);
        }
        return _data;
      });
}

// 获取总数，和每一叉树的所有 key
export function getAllKeys(datas, itemMainKey = "domid") {
  datas = objToArray(datas);
  let num = datas.length;
  let keys = getKeys(datas, itemMainKey);
  const childs = datas.map(data => {
    const obj = {
      [itemMainKey]: data[itemMainKey],
      childs: [],
      keys: []
    };
    if (data.childs && data.childs.length > 0) {
      const _obj = getAllKeys(data.childs);
      num += _obj.num;
      obj.num = _obj.num;
      obj.childs = [..._obj.childs];
      obj.keys = [..._obj.keys];
      keys = keys.concat(_obj.keys);
    }
    return obj;
  });
  return {
    num,
    childs,
    keys
  };
}

// 点击收藏 更改收藏状态
export function doFavEdit(datas, domid, itemMainKey = "domid") {
  datas = objToArray(datas);
  return datas.map(data => {
    const _data = { ...data };
    if (data[itemMainKey] === domid) {
      _data.fav = !_data.fav;
    } else if (data.childs && data.childs.length > 0) {
      _data.childs = doFavEdit(data.childs, domid);
    }
    return _data;
  });
}

// 删除不包含收藏节点的子集
export function doNoFavDelete(datas) {
  datas = objToArray(datas);
  return datas
    .map(data => {
      const _data = { ...data };
      _data.hasChildFav = false;
      if (data.childs && data.childs.length > 0) {
        const childs = doNoFavDelete(data.childs);
        const _childs = childs.filter(c => c.fav || c.hasChildFav);
        if (_childs.length > 0) {
          _data.hasChildFav = true;
          _data.childs = _childs;
        } else {
          _data.isLeaf = true;
          _data.childs = [];
        }
      }
      return _data;
    })
    .filter(c => c.fav || c.hasChildFav);
}



// WEBPACK FOOTER //
// ./ecology9/wea-tree-test/util/index.js